import { JourneyBadge } from '@usealloy/component-library';

import { Field } from '~/application-review/Fields';

import { getOutcomeDisplayText } from './helpers';

interface Props {
  evaluation: any;
  useBoldLabel?: boolean;
}

export function StatusOutcome({
  evaluation,
  useBoldLabel = false,
}: Props) {
  const outcome = getOutcomeDisplayText(evaluation);
  const outcomeIcon = evaluation?.outcome_icon_name;
  const outcomeColor = evaluation?.outcome_color
    ? `#${evaluation.outcome_color}`
    : undefined;

  const badge = (
    <JourneyBadge
      outcome={outcome}
      {...(outcomeIcon && { outcomeIcon })}
      {...(outcomeColor && { style: { backgroundColor: outcomeColor } })}
    >
      {outcome}
    </JourneyBadge>
  );

  return useBoldLabel ? (
    <>
      <div className="bold">Outcome</div>
      {badge}
    </>
  ) : (
    <Field fieldName="Outcome">{badge}</Field>
  );
}
